import React from 'react';
import { Wrench, AlertCircle } from 'lucide-react';
import PageTransition from '../components/PageTransition';

const Maintenance = () => {
  return (
    <PageTransition>
      <div className="min-h-screen bg-gradient-to-br from-orange-500 to-red-600 flex items-center justify-center p-4">
        <div className="bg-white rounded-3xl p-8 max-w-2xl w-full text-center shadow-2xl">
          <div className="mb-6">
            <Wrench size={80} className="mx-auto text-orange-600 animate-pulse" />
          </div>
          
          <h1 className="text-4xl font-black text-gray-900 mb-4">
            🔧 Sistema em Manutenção
          </h1>
          
          <p className="text-lg text-gray-600 mb-6">
            Estamos realizando melhorias no sistema para oferecer uma experiência ainda melhor.
          </p>
          
          <div className="bg-orange-50 border-2 border-orange-300 rounded-xl p-6 mb-6">
            <div className="flex items-start gap-3">
              <AlertCircle className="text-orange-600 flex-shrink-0 mt-1" size={24} />
              <div className="text-left">
                <p className="text-sm text-orange-900 font-semibold mb-2">
                  Por que estamos em manutenção?
                </p>
                <ul className="text-sm text-orange-800 space-y-1">
                  <li>• Implementação de novas funcionalidades</li>
                  <li>• Melhorias de desempenho</li>
                  <li>• Atualizações de segurança</li>
                  <li>• Otimização da experiência do usuário</li>
                </ul>
              </div>
            </div>
          </div>
          
          <p className="text-gray-500 mb-4">
            Volte em breve! Estaremos de volta em instantes.
          </p>
          
          <div className="flex justify-center gap-2">
            <div className="w-3 h-3 bg-orange-500 rounded-full animate-bounce" style={{animationDelay: '0s'}}></div>
            <div className="w-3 h-3 bg-orange-500 rounded-full animate-bounce" style={{animationDelay: '0.1s'}}></div>
            <div className="w-3 h-3 bg-orange-500 rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
          </div>
          
          <p className="text-xs text-gray-400 mt-8">
            Em caso de urgência, entre em contato com o suporte.
          </p>
        </div>
      </div>
    </PageTransition>
  );
};

export default Maintenance;
